if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification && typeof cartNotification.setActiveElement === 'function') {
        cartNotification.setActiveElement(this.openedBy);
      }
      this.modalContent.innerHTML = '';
      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      if (opener) {
        opener.setAttribute('aria-disabled', 'true');
        opener.classList.add('loading');
        const spinnerStart = opener.querySelector('.loading__spinner, .loading-overlay__spinner');
        if (spinnerStart) spinnerStart.classList.remove('hidden');
      }

      const url = opener ? opener.getAttribute('data-product-url') : null;
      fetch(url)
        .then(function(r){ return r.text(); })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          this.productElement = doc.querySelector('section[id^="MainProduct-"]');
          if (!this.productElement) return;

          // Copy color/gradient classes from product section so modal matches product theme (Herd behavior)
          if (this.productElement.classList && this.modalContent && this.modalContent.classList) {
            this.productElement.classList.forEach((cls) => {
              if (cls.indexOf('color-') === 0 || cls === 'gradient') {
                this.modalContent.classList.add(cls);
              }
            });
          }

          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);



this.polishThemeVariantPicker(opener ? opener.getAttribute('data-product-url') : null);


          // Initialize accelerated payment buttons & 3D/AR if present
          if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();            // perf: responsive sizes like Herd
          this.preventVariantURLSwitching();  // prevent URL pollution in modal
          super.show(opener);
        })
        .catch(function(err){ console.error(err); })
        .finally(() => {
          if (opener) {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            const spinnerEnd = opener.querySelector('.loading__spinner, .loading-overlay__spinner');
            if (spinnerEnd) spinnerEnd.classList.add('hidden');
          }
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;
      // Re-inject <script> so inline scripts execute (innerHTML disables execution by default)
      const scripts = element.querySelectorAll('script');
      scripts.forEach((oldScript) => {
        const s = document.createElement('script');
        Array.prototype.slice.call(oldScript.attributes).forEach((a) => s.setAttribute(a.name, a.value));
        s.appendChild(document.createTextNode(oldScript.innerHTML));
        oldScript.parentNode.replaceChild(s, oldScript);
      });
    }

    preventVariantURLSwitching() {
      // Cover both radios and selects; be null-safe
      const picker = this.modalContent.querySelector('variant-radios, variant-selects');
      if (picker) picker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      // Avoid nested modals/focus traps
      const nested = this.productElement.querySelectorAll('modal-dialog');
      if (nested && nested.length) nested.forEach((m) => m.remove());

      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement && this.productElement.dataset ? this.productElement.dataset.section : null;
      if (!sectionId) return;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, 'quickadd-' + sectionId);

      // Union of both versions for maximum compatibility
      const marks = this.productElement.querySelectorAll('variant-selects, variant-radios, product-info');
      marks.forEach((el) => { el.dataset.originalSection = sectionId; });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;
      galleryList.setAttribute('role', 'presentation');
      const slides = galleryList.querySelectorAll('[id^="Slide-"]');
      if (slides && slides.length) slides.forEach((li) => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      if (!product || !product.classList.contains('product--columns')) return;

      const imgs = product.querySelectorAll('.product__media img');
      if (!imgs || !imgs.length) return;

      let sizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      if (product.classList.contains('product--medium')) {
        sizes = sizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        sizes = sizes.replace('715px', '495px');
      }
      imgs.forEach((img) => img.setAttribute('sizes', sizes));
    }


polishThemeVariantPicker(productUrl) {
  const root = this.modalContent;

  const form =
    root.querySelector('product-form form') ||
    root.querySelector('form[action^="/cart"]');
  if (!form) return;

  // Price helpers (to avoid "£X Sold out")
  const priceRoot = root.querySelector('.price, price');
  const originalPriceHTML = priceRoot ? priceRoot.innerHTML : null;
  const showSoldOutOnly = () => {
    if (!priceRoot) return;
    priceRoot.dataset.qaOverrode = '1';
    priceRoot.classList.remove('price--on-sale');
    priceRoot.innerHTML =
      '<span class="price-item price-item--regular">Sold out</span>';
  };
  const restorePrice = () => {
    if (priceRoot && priceRoot.dataset.qaOverrode === '1' && originalPriceHTML != null) {
      priceRoot.innerHTML = originalPriceHTML;
      delete priceRoot.dataset.qaOverrode;
    }
  };

  const addBtn =
    root.querySelector('button[name="add"], .product-form__submit, [data-add-to-cart]');

  const setAddDisabled = (d) => {
    if (!addBtn) return;
    addBtn.disabled = !!d;
    addBtn.setAttribute('aria-disabled', String(!!d));
  };

  // Resolve product handle
  const href =
    productUrl ||
    (root.querySelector('a[href*="/products/"]')?.getAttribute('href') || '');
  if (!href) return;
  const handleMatch = new URL(href, window.location.origin)
    .pathname.match(/\/products\/([^\/?#]+)/i);
  if (!handleMatch) return;
  const handle = decodeURIComponent(handleMatch[1]);

  // Fetch public product JSON
  fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } })
    .then((r) => r.json())
    .then((product) => {
      const variants = Array.isArray(product?.variants) ? product.variants : [];
      if (!variants.length) return;

      const norm = (s) =>
        String(s || '').replace(/\u00a0/g, ' ').trim().toLowerCase();
      const byOpt1 = new Map(); // single-option products
      variants.forEach((v) => byOpt1.set(norm(v.option1), v));

      // --- SELECT path (theme "variant-selects")
      const select =
        root.querySelector('variant-selects select') ||
        root.querySelector('.product-form__input select');
      if (select) {
        Array.from(select.options).forEach((opt) => {
          if (!opt.value) return;
          const v =
            byOpt1.get(norm(opt.value)) || byOpt1.get(norm(opt.textContent));
          if (!v) return;
          if (!v.available) {
            opt.disabled = true;
            if (!/sold out/i.test(opt.textContent)) {
              opt.textContent =
                `(Sold out) ` + opt.textContent.replace(/^\(Sold out\)\s*/i, '');
            }
          }
        });

        // If theme preselected a sold-out variant → unselect, disable ATC, and clean price
        const selOpt = select.options[select.selectedIndex];
        if (selOpt && selOpt.disabled) {
          // move to first (usually placeholder) and disable ATC
          select.selectedIndex = 0;
          setAddDisabled(true);
          restorePrice();
          // signal theme listeners that selection changed
          try { select.dispatchEvent(new Event('change', { bubbles: true })); } catch (_) {}
        }

        // Guard future changes
        select.addEventListener('change', () => {
          const v =
            byOpt1.get(norm(select.value)) || null;
          if (!v) { setAddDisabled(true); restorePrice(); return; }
          if (!v.available) { setAddDisabled(true); showSoldOutOnly(); }
          else { setAddDisabled(false); restorePrice(); }
        });
      }

      // --- RADIOS path (theme "variant-radios", single option)
      const radios = root.querySelectorAll('variant-radios input[type="radio"]');
      if (radios.length) {
        radios.forEach((input) => {
          const v = byOpt1.get(norm(input.value));
          if (!v) return;
          if (!v.available) {
            input.disabled = true;
            input.setAttribute('aria-disabled', 'true');
            const label =
              input.closest('label') ||
              input.parentElement?.querySelector('label') ||
              input.nextElementSibling;
            if (label && !/sold out/i.test(label.textContent)) {
              label.textContent =
                `(Sold out) ` + label.textContent.replace(/^\(Sold out\)\s*/i, '');
            }
          }
        });

        const checked = root.querySelector('variant-radios input[type="radio"]:checked');
        if (checked && checked.disabled) {
          checked.checked = false;
          setAddDisabled(true);
          restorePrice();
        }

        root.addEventListener('change', (e) => {
          if (!e.target?.matches?.('variant-radios input[type="radio"]')) return;
          const v = byOpt1.get(norm(e.target.value));
          if (!v) { setAddDisabled(true); restorePrice(); return; }
          if (!v.available) { setAddDisabled(true); showSoldOutOnly(); }
          else { setAddDisabled(false); restorePrice(); }
        });
      }
    })
    .catch(() => {});
}


  });
}

